import { fmtClock } from "../hooks/useBuildClock";
import { stageLabel } from "./BuildStageList";

// Time-based build progress: current stage label, asymptotic bar (never claims 100 %), elapsed / timeout clocks.
export const ProgressBar = ({ creation, waiting, elapsed }) => {
  const pct = Math.min(96, Math.round(100 * (1 - Math.exp(-elapsed / 55))));
  return (
    <div>
      <div className="h-3 rounded-full bg-muted overflow-hidden">
        <div
          data-testid="build-progress-bar"
          className={`h-full rounded-full transition-[width] duration-1000 ${waiting ? "bg-muted-foreground/40" : "bg-primary"}`}
          style={{ width: `${waiting ? 100 : pct}%` }}
        />
      </div>
      <div className="flex justify-between mt-2 text-xs font-mono2 text-muted-foreground">
        <span data-testid="build-stage-caption">{waiting ? "Paused — retrying automatically" : `${stageLabel(creation)}…`}</span>
        <span data-testid="build-timer">{fmtClock(elapsed)}</span>
      </div>
    </div>
  );
};
